module.exports = __webpack_public_path__ + "img/selected3-min.1e4bc5c4.png";